import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Col, Container, Row } from "reactstrap";
import { Modal } from "react-bootstrap";
import { numberWithCommas } from "../../utils/customFunction";
import ReactTooltip from "react-tooltip";
import {
  getAllLoanApplications,
  updateLoanApplicationStatus,
} from "../../stores/services/provident-funds.service";
import ViewLoanApplication from "./ViewLoanApplication";
import { useHistory } from "react-router-dom";

function LoanListing() {
  const history = useHistory();
  const [allData, setAllData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [refreshData, setRefreshData] = useState<boolean>(false);
  const [selectedItems, setSelectedItems] = useState<any>({});
  const [viewModalFlag, setViewModalFlag] = useState<boolean>(false);
  const [alertModalFlag, setAlertModalFlag] = useState<boolean>(false);
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";

  const getListing = async () => {
    try {
      setLoading(true);
      const response = await getAllLoanApplications(email, amcCode, "", "", "");
      if (response.data.status == 200) {
        setAllData(response.data.data);
      } else {
        toast.error("No record found!");
        setAllData([]);
      }
    } catch (error: any) {
      setAllData([]);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getListing();
  }, [refreshData]);

  const renderData = () => {
    return allData?.map((items: any, index: any) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{items?.symbol_code}</td>
          <td>{items?.fund_name}</td>
          <td>{items?.folio_no}</td>
          <td>{items?.employee_name}</td>
          <td>{numberWithCommas(items?.loan_amount || 0)}</td>
          <td>{numberWithCommas(items?.number_of_installment || 0)}</td>
          <td>{moment(items?.created_at)?.format("DD-MM-YYYY")}</td>
          <td>{items?.loan_status}</td>
          <td className="text-center">
            <div className="d-flex">
              <ReactTooltip
                textColor="white"
                backgroundColor="black"
                effect="float"
              />
              <button
                data-tip="View"
                onClick={() => {
                  setSelectedItems(items);
                  setViewModalFlag(true);
                }}
                type="button"
                className="btn-icon btn-link like btn btn-info btn-sm"
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="content">
      {/* ------------------------  View Modal ------------------ */}
      <Modal
        className=""
        dialogClassName="modal90w"
        show={viewModalFlag ? true : false}
        size="xl"
        backdrop={true}
        onHide={() => {
          setViewModalFlag(false);
          setSelectedItems("");
        }}
        centered={true}
      >
        <div className="modal-header ">
          <button
            aria-hidden={true}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setViewModalFlag(false);
              setSelectedItems("");
            }}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <h6 className="title title-up">View Loan Application</h6>
        </div>
        <div className="modal-body">
          <ViewLoanApplication selectedItems={selectedItems} />
        </div>
      </Modal>

      <Row>
        <Col md="12">
          <Container fluid>
            <ToastContainer limit={1} />
            <div className="card">
              <div className="d-flex align-items-center"></div>

              <div className="">
                <div className="card-header">
                  <div className="card-title">
                    <h4 className="d-flex justify-content-between align-items-center">
                      Loan Application Listing
                      <button
                        className="btn btn-primary btn-sm float-right"
                        onClick={() => {
                          history.push("/admin/add-loan-application");
                        }}
                      >
                        <i className="fa fa-plus mr-2"></i> Loan
                      </button>
                    </h4>
                  </div>
                </div>
                <div className="card-body">
                  {/* <Row>
                                        <Col md="4">

                                        </Col>
                                        <Col md="4">
                                            <button
                                                style={{
                                                    marginTop: "1px",
                                                }}
                                                className="btn btn-primary"
                                            // onClick={searchFundData}
                                            >
                                                <i className="fa fa-search"></i> Search
                                            </button>
                                        </Col>
                                    </Row> */}
                  {loading ? (
                    <div className="d-flex justify-content-center my-5">
                      <i
                        className="fa fa-spinner fa-spin fa-3x"
                        aria-hidden="true"
                      ></i>
                    </div>
                  ) : !loading && allData?.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Sr.
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Fund Code
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Fund Name
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Employee Code
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Employee Name
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Loan Amount
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Loan Installment
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Created At
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Status
                          </th>
                          <th
                            style={{
                              paddingLeft: "7px",
                              paddingRight: "7px",
                            }}
                          >
                            Actions
                          </th>
                        </thead>
                        <tbody>{renderData()}</tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center">
                      <b className="my-5">No record found!</b>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default LoanListing;
